import React from "react";
import { OrderIndData } from "../../../data/trading/orderIndicative/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { useDisplaySingleEmementStyles } from "../../useDisplaySingleEmementStyles";
import { DisplayBoolNumber } from "../../components/common/DisplayBoolNumber";
import { Status } from "../../../data/models";
import { renderOrderIndSide } from "./columRenderers";

export interface DisplayOrderIndMainAttributesProps {
  orderInd: OrderIndData;
}

export const DisplayOrderIndMainAttributes: React.FunctionComponent<DisplayOrderIndMainAttributesProps> = ({
  orderInd,
}) => {
  const style = useDisplaySingleEmementStyles();

  const { getString, getDateString, getDateTimeString, getFormatedNumberString, getFormatedNumberString4 } = React.useContext(
    LocalizationContext
  );

  return (
    <div className={style.root}>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("orderSide")}</span>
        <span className={style.value}>{renderOrderIndSide(orderInd)}</span>
        {/*           <span className={style.value}>{orderInd.side}</span>  */}
      </div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("bankCode")}</span>
        <span className={style.value}>{orderInd.productCode}</span>
      </div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("orderProduct")}</span>
        <span className={style.value}>{orderInd.productName}</span>
      </div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("orderPrice")}</span>
        <span className={style.value}>{orderInd.price}</span>
      </div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("orderQty")}</span>
        <span className={style.value}>{getFormatedNumberString(orderInd.qty)}</span>
      </div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("orderIndDescr")}</span>
        <span className={style.value}>{orderInd.description}</span>
      </div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("orderIndComment")}</span>
        <span className={style.value}>{orderInd.comment}</span>
      </div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("orderbrokName")}</span>
        <span className={style.value}>{orderInd.employeeName}</span>
      </div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("orderIndTime")}</span>
        <span className={style.value}>{getDateString(orderInd.creTime)}</span>
      </div>
      <div className={`${style.row} ${style.rowBorder}`}>
        <span className={style.label}>{getString("empStatus")}</span>
        <span className={style.value}>
          <DisplayBoolNumber
            value={orderInd.status}
            thrutyValue={Status.Active}
            className={style.icon}
          />
        </span>
      </div>
    </div>
  );
};
